import { render, staticRenderFns } from "./LanguageSettingTabComponents.vue?vue&type=template&id=1934332b&scoped=true&"
import script from "./LanguageSettingTabComponents.vue?vue&type=script&lang=js&"
export * from "./LanguageSettingTabComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934332b",
  null
  
)

export default component.exports